import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, convertToUppercase } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { Input, Button, BackButton, Title, Subtitle, ScannerCode } from '../../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';

const ReprocessEdit = (props) => {
    const [change, setChange] = useState({});

    useEffect(() => {
        if (props.location?.state?.change) {
            const item = props.location.state.change;
            //const lastTransmission = item.transmissions ? item.transmissions.slice(-1)[0] : {}
            var changeProps = item;

            changeProps.barCode = item.cim ? item.cim : '';
            changeProps.location = item.location ? item.location : '';
            changeProps.cimQuantity = item.cimQuantity ? item.cimQuantity : '';
            changeProps.lastMessage = item.message;
            setChange({ ...changeProps });
        }

        // eslint-disable-next-line
    }, []);


    const onChange = (event) => {
        onValueChange(event, change, setChange);
    };

    const onConfirm = () => {

        let model = {
            id: change.id,
            cim: change.barCode,
            location: change.location,
            cimQuantity: change.cimQuantity

        }

        props.reprocessTransmission(model,
            () => { props.history.go(-1); });

    }

    const scannerBarCode = (value) => {
        change.barCode = value;
        setChange({ ...change });
    };

    const scannerLocation = (value) => {
        change.location = value;
        setChange({ ...change });
    };


    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('reprocess-monitor', 'physical-confirmation')} />
                <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('change', 'physical-confirmation')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '5px', paddingBlockEnd: '1px' }}>
                            <div className="no-padding" style={{ marginBottom: '30px' }}>
                                <span className="sixth-text-color" style={{ display: 'block' }}>{change.partNumberCode || ''}</span>
                                <span className="fourth-text-color" style={{ display: 'block' }}>{change.lastMessage || 'Erro não especificado.'}</span>
                            </div>
                            <form style={{ marginBottom: '20px' }}>
                                <div className="row">
                                    <div className="input-field no-padding col s11">
                                        <ScannerCode onScanner={scannerBarCode} />
                                        <Input
                                            required
                                            label="CIM, Master CIM ou Cim Pallet"
                                            id="barCode"
                                            name="barCode"
                                            type="text"
                                            defaultValue={change?.barCode}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s11">
                                        <Input
                                            required
                                            label="Qtd. CIM"
                                            id="cimQuantity"
                                            name="cimQuantity"
                                            type="number"
                                            defaultValue={change?.cimQuantity}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="input-field no-padding col s11">
                                        <ScannerCode onScanner={scannerLocation} />
                                        <Input
                                            required
                                            label="Locação"
                                            id="location"
                                            name="location"
                                            type="text"
                                            defaultValue={change?.location}
                                            onChange={onChange}
                                            onKeyUp={convertToUppercase}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reprocessTransmission: (model, callback) => {
            dispatch(ChangeLocationService.reprocessTransmission(model, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessEdit)));